import * as S from "./NotificationEventConent.styles";
import { NotificationEventContentItem } from "../../molcules/NotificationContentItem";
interface NotificationEventContentProps {}

export const NotificationEventContent = ({}: NotificationEventContentProps) => {
    const dummydata = [
    {
        header: "공지사항",
        date: "2024.07.04",
        content: "선불 충전금 운용 현황 공사(24년 2분기)",
    },
    {
        header: "이벤트",
        date: "2024.07.01",
        content: "2024년 6월 이벤트 진행 일정 안내",
    },
    {
        header: "공지사항",
        date: "2024.05.14",
        content: "고객센터 전화상담 및 일부 서비스 일시 중단 안내(5월 22일, 5월 24일)",
    },
    {
        header: "공지사항",
        date: "2024.04.24",
        content: "개인정보처리방침 개정 안내(5월 2일 시행)",
    },
    ];

    return (
    <S.MainContentsSection>
        <S.MainContentsList>
            <NotificationEventContentItem dummydata={dummydata} />
        </S.MainContentsList>
    </S.MainContentsSection>
    );
};
